// @flow
import client from '../../client'

// API Endpoinds
export const COVERAGE_ENDPOINT = '/data-entry/providers/coverage/'

/**
 * Returns if coordinates are supported or not
 * @param {Object} data Data
 * @param {number} data.lat Latitude
 * @param {number} data.lng Longitude
 * @return {Promise|Error} A resolved Promise or Rejected with an Error
 */
export const checkCoverage = (data: {
  lat: number,
  lng: number,
}): Promise<any> => client.get(COVERAGE_ENDPOINT, { query: data })

export default checkCoverage
